module.exports = __webpack_public_path__ + "res/13-img_bg_l.29ff431ad8c979f3fb30def244100822.png";